import React from 'react';
import Button from '@atlaskit/button/standard-button';
import Heading from '@atlaskit/heading';
import MoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--more';
import { Box } from '@atlaskit/primitives';
import {
	AdControlDropdownMenu,
	DismissalButton,
	ReasonsButton,
} from '@atlassian/ad-control-toolkit';
import { useIntl } from '@atlassian/jira-intl';
import { ContextualAnalyticsData, MODAL } from '@atlassian/jira-product-analytics-bridge';
import messages from '../messages.tsx';
import AdControlsReasonsModal from './reasons-modal.tsx';

type Props = {
	onClickDismiss: () => Promise<void>;
	menuButtonTestId?: string;
};

const AdControls = ({ onClickDismiss, menuButtonTestId }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<AdControlDropdownMenu
			itemId="placeholder-template-ad-controls"
			trigger={({ triggerRef, ...props }) => (
				<Box paddingInline="space.050">
					<Button
						{...props}
						testId={menuButtonTestId}
						appearance="subtle"
						spacing="compact"
						iconBefore={
							<MoreIcon color="currentColor" label="more" spacing="none" LEGACY_size="small" />
						}
						ref={triggerRef}
						interactionName="auto-generated.jira-issue-view-base.content.confluence-placeholder-template-experiment.common.ad-controls.button"
					/>
				</Box>
			)}
		>
			{(props) => (
				<>
					<DismissalButton
						{...props}
						flagProps={{
							title: formatMessage(messages.dismissFlagTitle),
							description: formatMessage(messages.dismissFlagDescription),
						}}
						onClick={onClickDismiss}
					/>
					<ReasonsButton
						{...props}
						modalProps={{
							title: <Heading size="medium">{formatMessage(messages.reasonsModalTitle)}</Heading>,
							body: (
								<ContextualAnalyticsData sourceName="adControlsReasons" sourceType={MODAL}>
									<AdControlsReasonsModal />
								</ContextualAnalyticsData>
							),
						}}
					/>
				</>
			)}
		</AdControlDropdownMenu>
	);
};

export default AdControls;
